// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__7rZz9","detailsBorder":"styles_detailsBorder__2RqL4"};